<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack('dateForm')">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Create a Shift</ion-title>
    <!-- <ion-buttons slot="end">
      <ion-button
        @click="goNext('dateForm')"
        :disabled="formsData.dateForm.disabled"
      >
        <span>Next</span>
      </ion-button>
    </ion-buttons> -->
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container">
      <el-form :model="formsData.dateForm" :rules="formsData.dateForm.rules"
        :ref="(el) => (formsData.dateForm.ref = el)" :label-position="'top'" @submit.prevent="goNext('dateForm')">
        <!-- <div class="form_text page_padding_top">
          <div class="title">
            Hourly Payment range
          </div>
          <div class="text_note">
            (Excluding super)
          </div>
        </div> -->

        <div class="auth-header">
          <div class="auth-heading">
            <h1>Hourly Payment Range</h1>
            <p class="auth-subtext" v-if="isAustralia">(Excluding Super)</p>
          </div>
          <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                </div>
        </div>
        <el-form-item v-if="onlyCommonDays" class="rate_form_inputs_wrapper" prop="rate">
          <el-form-item label="Minimum Pay Rate" :required="true" class="is-no-asterisk">
            <div class="el-input el-input--suffix">
              <input type="tel" class="input_currency el-input__inner" :value="formsData.dateForm.rate.value.minRate"
                :placeholder="'0.00'" v-imask="formsData.dateForm.rate.mask" @accept="
                  onFormMaskAccept($event, 'dateForm', {
                    name: 'rate',
                    value: 'minRate',
                  })
                " @blur="checkFormValidation('dateForm', true, 'rate')" />
              <span class="el-input__suffix" v-if="isAustralia">AUD</span>
              <span class="el-input__suffix" v-else>USD</span>
            </div>
          </el-form-item>

          <el-form-item label="Maximum Pay Rate" :required="true" class="is-no-asterisk">
            <div class="el-input el-input--suffix">
              <input type="tel" class="input_currency el-input__inner" :value="formsData.dateForm.rate.value.maxRate"
                :placeholder="'0.00'" v-imask="formsData.dateForm.rate.mask" @accept="
                  onFormMaskAccept($event, 'dateForm', {
                    name: 'rate',
                    value: 'maxRate',
                  })
                " @blur="checkFormValidation('dateForm', true, 'rate')" />
               <span class="el-input__suffix" v-if="isAustralia">AUD</span>
               <span class="el-input__suffix" v-else>USD</span>
            </div>
          </el-form-item>


        </el-form-item>
        <div class="base"
          v-if="onlyCommonDays && (formsData.dateForm.rate.value.minRate || formsData.dateForm.rate.value.maxRate) && isAustralia">
          <el-form-item class="base-left" v-if="formsData.dateForm.rate.value.minRate">
            <div>
              Min. Super: <strong> {{ calculatePerHrRateSuper(formsData.dateForm.rate.value.minRate) }}</strong>
            </div>
            <div>
              Min. Base Rate Inc. Super: <strong> {{ calculateTotalRate(formsData.dateForm.rate.value.minRate)
                }}</strong>
            </div>
          </el-form-item>
          <el-form-item class="base-right" v-if="formsData.dateForm.rate.value.maxRate">
            <div>
              Max. Super: <strong>{{ calculatePerHrRateSuper(formsData.dateForm.rate.value.maxRate) }}</strong>
            </div>
            <div>
              Max. Base Rate Inc. Super: <strong>{{ calculateTotalRate(formsData.dateForm.rate.value.maxRate)
                }}</strong>
            </div>
          </el-form-item>
        </div>
        <el-switch class="weekend-rate-switch" v-model="samePayRate" active-text="Equal Rate"
          v-if="checkWeekend('saturday') && checkWeekend('sunday')">
        <!-- <el-switch class="weekend-rate-switch" v-model="samePayRate" active-text="Different Rate"
          inactive-text="Equal Rate" v-if="checkWeekend('saturday') && checkWeekend('sunday')"> -->
        </el-switch>
        <div class="form_text page_padding_top" v-if="checkWeekend('saturday') && checkWeekend('sunday')">
          <div class="title main-heading">
            Weekend Pay Rates
          </div>

        </div>
        
        <div v-if="samePayRate">
          <el-form-item v-if="checkWeekend('all')" class="rate_form_inputs_wrapper" prop="weekendRate">
            <el-form-item label="Weekend Minimum Pay Rate" :required="true" class="is-no-asterisk">
              <div class="el-input el-input--suffix">
                <input type="tel" class="input_currency el-input__inner"
                  :value="formsData.dateForm.weekendRate.value.weekendMinRate" :placeholder="'0.00'"
                  v-imask="formsData.dateForm.weekendRate.mask" @accept="
                  onFormMaskAccept($event, 'dateForm', {
                    name: 'weekendRate',
                    value: 'weekendMinRate',
                  })
                " @blur="checkFormValidation('dateForm', true, 'weekendRate')" />
                <span class="el-input__suffix" v-if="isAustralia">AUD</span>
                <span class="el-input__suffix" v-else>USD</span>
              </div>
            </el-form-item>

            <el-form-item label="Weekend Maximum Pay Rate" :required="true" class="is-no-asterisk">
              <div class="el-input el-input--suffix">
                <input type="tel" class="input_currency el-input__inner"
                  :value="formsData.dateForm.weekendRate.value.weekendMaxRate" :placeholder="'0.00'"
                  v-imask="formsData.dateForm.weekendRate.mask" @accept="
                  onFormMaskAccept($event, 'dateForm', {
                    name: 'weekendRate',
                    value: 'weekendMaxRate',
                  })
                " @blur="checkFormValidation('dateForm', true, 'weekendRate')" />
                <span class="el-input__suffix" v-if="isAustralia">AUD</span>
                <span class="el-input__suffix" v-else>USD</span>
              </div>
            </el-form-item>

          </el-form-item>
          <div class="base"
            v-if="checkWeekend('all') && (formsData.dateForm.weekendRate.value.weekendMinRate || formsData.dateForm.weekendRate.value.weekendMaxRate) && isAustralia">
            <el-form-item class="base-left" v-if="formsData.dateForm.weekendRate.value.weekendMinRate">
              <div>
                Min. Super: <strong> {{ calculatePerHrRateSuper(formsData.dateForm.weekendRate.value.weekendMinRate)
                  }}</strong>
              </div>
              <div>
                Min. Base Rate Inc. Super: <strong> {{
                  calculateTotalRate(formsData.dateForm.weekendRate.value.weekendMinRate) }}</strong>
              </div>
            </el-form-item>
            <el-form-item class="base-right" v-if="formsData.dateForm.weekendRate.value.weekendMaxRate">
              <div>
                Max. Super: <strong> {{ calculatePerHrRateSuper(formsData.dateForm.weekendRate.value.weekendMaxRate)
                  }}</strong>
              </div>
              <div>
                Max. Base Rate Inc. Super: <strong>{{
                  calculateTotalRate(formsData.dateForm.weekendRate.value.weekendMaxRate) }}</strong>
              </div>
            </el-form-item>
          </div>
        </div>

        <div v-else>
          <el-form-item v-if="checkWeekend('saturday')" class="rate_form_inputs_wrapper" prop="weekendSaturdayRate">
            <el-form-item label="Saturday Minimum Pay Rate" :required="true" class="is-no-asterisk">
              <div class="el-input el-input--suffix">
                <input type="tel" class="input_currency el-input__inner"
                  :value="formsData.dateForm.weekendSaturdayRate.value.saturdayMinRate" :placeholder="'0.00'"
                  v-imask="formsData.dateForm.weekendSaturdayRate.mask" @accept="
                  onFormMaskAccept($event, 'dateForm', {
                    name: 'weekendSaturdayRate',
                    value: 'saturdayMinRate',
                  })
                " @blur="checkFormValidation('dateForm', true, 'weekendSaturdayRate')" />
                <span class="el-input__suffix" v-if="isAustralia">AUD</span>
                <span class="el-input__suffix" v-else>USD</span>
              </div>
            </el-form-item>
            <el-form-item label="Saturday Maximum Pay Rate" :required="true" class="is-no-asterisk">
              <div class="el-input el-input--suffix">
                <input type="tel" class="input_currency el-input__inner"
                  :value="formsData.dateForm.weekendSaturdayRate.value.saturdayMaxRate" :placeholder="'0.00'"
                  v-imask="formsData.dateForm.weekendSaturdayRate.mask" @accept="
                  onFormMaskAccept($event, 'dateForm', {
                    name: 'weekendSaturdayRate',
                    value: 'saturdayMaxRate',
                  })
                " @blur="checkFormValidation('dateForm', true, 'weekendSaturdayRate')" />
                <span class="el-input__suffix" v-if="isAustralia">AUD</span>
                <span class="el-input__suffix" v-else>USD</span>
              </div>
            </el-form-item>

          </el-form-item>
          <div class="base"
            v-if="checkWeekend('saturday') && (formsData.dateForm.weekendSaturdayRate.value.saturdayMinRate || formsData.dateForm.weekendSaturdayRate.value.saturdayMaxRate) && isAustralia">
            <el-form-item class="base-left" v-if="formsData.dateForm.weekendSaturdayRate.value.saturdayMinRate">
              <div>
                Min. Super: <strong>{{
                  calculatePerHrRateSuper(formsData.dateForm.weekendSaturdayRate.value.saturdayMinRate) }}</strong>
              </div>
              <div>
                Min. Base Rate Inc. Super: <strong> {{
                  calculateTotalRate(formsData.dateForm.weekendSaturdayRate.value.saturdayMinRate) }}</strong>
              </div>
            </el-form-item>
            <el-form-item class="base-right" v-if="formsData.dateForm.weekendSaturdayRate.value.saturdayMaxRate">
              <div>
                Max. Super: <strong>{{
                  calculatePerHrRateSuper(formsData.dateForm.weekendSaturdayRate.value.saturdayMaxRate) }}</strong>
              </div>
              <div>
                Max. Base Rate Inc. Super: <strong>{{
                  calculateTotalRate(formsData.dateForm.weekendSaturdayRate.value.saturdayMaxRate) }}</strong>
              </div>
            </el-form-item>
          </div>
          <el-form-item v-if="checkWeekend('sunday')" class="rate_form_inputs_wrapper" prop="weekendSundayRate">
            <el-form-item label="Sunday Min. Pay Rate" :required="true" class="is-no-asterisk">
              <div class="el-input el-input--suffix">
                <input type="tel" class="input_currency el-input__inner"
                  :value="formsData.dateForm.weekendSundayRate.value.sundayMinRate" :placeholder="'0.00'"
                  v-imask="formsData.dateForm.weekendSundayRate.mask" @accept="
                  onFormMaskAccept($event, 'dateForm', {
                    name: 'weekendSundayRate',
                    value: 'sundayMinRate',
                  })
                " @blur="checkFormValidation('dateForm', true, 'weekendSundayRate')" />
                <span class="el-input__suffix" v-if="isAustralia">AUD</span>
                <span class="el-input__suffix" v-else>USD</span>
              </div>
            </el-form-item>
            <el-form-item label="Sunday Max. Pay Rate" :required="true" class="is-no-asterisk">
              <div class="el-input el-input--suffix">
                <input type="tel" class="input_currency el-input__inner"
                  :value="formsData.dateForm.weekendSundayRate.value.sundayMaxRate" :placeholder="'0.00'"
                  v-imask="formsData.dateForm.weekendSundayRate.mask" @accept="
                  onFormMaskAccept($event, 'dateForm', {
                    name: 'weekendSundayRate',
                    value: 'sundayMaxRate',
                  })
                " @blur="checkFormValidation('dateForm', true, 'weekendSundayRate')" />
                <span class="el-input__suffix" v-if="isAustralia">AUD</span>
                <span class="el-input__suffix" v-else>USD</span>
              </div>
            </el-form-item>
          </el-form-item>
          <div class="base"
            v-if="checkWeekend('sunday') && (formsData.dateForm.weekendSundayRate.value.sundayMinRate || formsData.dateForm.weekendSundayRate.value.sundayMaxRate) && isAustralia">
            <el-form-item class="base-left" v-if="formsData.dateForm.weekendSundayRate.value.sundayMinRate">
              <div>
                Min. Super: <strong>{{ calculatePerHrRateSuper(formsData.dateForm.weekendSundayRate.value.sundayMinRate)
                  }}</strong>
              </div>
              <div>
                Min. Base Rate Inc. Super: <strong>{{
                  calculateTotalRate(formsData.dateForm.weekendSundayRate.value.sundayMinRate) }}</strong>
              </div>
            </el-form-item>
            <el-form-item class="base-right" v-if="formsData.dateForm.weekendSundayRate.value.sundayMaxRate">
              <div>
                Max. Super: <strong> {{
                  calculatePerHrRateSuper(formsData.dateForm.weekendSundayRate.value.sundayMaxRate) }}</strong>
              </div>
              <div>
                Max. Base Rate Inc. Super: <strong>{{
                  calculateTotalRate(formsData.dateForm.weekendSundayRate.value.sundayMaxRate) }}</strong>
              </div>
            </el-form-item>
          </div>
        </div>

      </el-form>
      <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
            </div>
      <el-button class="primary w-full mt-auto" @click="goNext('dateForm')" :disabled="formsData.dateForm.disabled">
        Next
      </el-button>
    </div>
  </div>
</template>

<script>
"@/components/Vendor/Element";

import {
  onMounted,
  inject,
  ref,
  reactive,
  watch,
} from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import moment from "moment";
import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  IonTitle,
} from "@ionic/vue";
import { useStore } from "vuex";
import {
  useRouter,
  // useRoute
} from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import formMasks from "@/hooks/form/mask/mask";

import IMaskDirective from "@/directives/vue-imask/directive";
import IMask from "imask/esm/imask";

import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
import SvgIcon from '@/components/Svg/SvgIcon.vue'; 

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,
    SvgIcon
  },
  directives: {
    imask: IMaskDirective,
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const setPageClassGlobal = inject("setPageClassGlobal");
    const jobCreatePageData = $store.getters.getJobCreatePageData;
    console.log("created job page data", jobCreatePageData);

    const shedule = jobCreatePageData.schedule;
    const minRate = jobCreatePageData.minRate;
    const maxRate = jobCreatePageData.maxRate;
    const weekendMinRate = jobCreatePageData.weekendMinRate;
    const weekendMaxRate = jobCreatePageData.weekendMaxRate;
    const saturdayMinRate = jobCreatePageData.saturdayMinRate;
    const saturdayMaxRate = jobCreatePageData.saturdayMaxRate;
    const sundayMinRate = jobCreatePageData.sundayMinRate;
    const sundayMaxRate = jobCreatePageData.sundayMaxRate;
    const globalSuperCharge = process.env.VUE_APP_SUPER_CHARGE;
    const samePayRate = ref(false);
    const isAustralia = isAustraliaRegion();

    const formsDataArray = reactive({
      dateForm: {
        rate: {
          value: {
            minRate: minRate
              ? IMask.createMask(formMasks.rate).resolve("" + minRate)
              : null,
            maxRate: maxRate
              ? IMask.createMask(formMasks.rate).resolve("" + maxRate)
              : null,
          },

          mask: formMasks.rate,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "rateRange",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        weekendRate: {
          value: {
            weekendMinRate: weekendMinRate
              ? IMask.createMask(formMasks.rate).resolve("" + weekendMinRate)
              : null,
            weekendMaxRate: weekendMaxRate
              ? IMask.createMask(formMasks.rate).resolve("" + weekendMaxRate)
              : null,
          },
          mask: formMasks.rate,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "weekendRateRange",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        weekendSaturdayRate: {
          value: {
            saturdayMinRate: saturdayMinRate
              ? IMask.createMask(formMasks.rate).resolve("" + saturdayMinRate)
              : null,
            saturdayMaxRate: saturdayMaxRate
              ? IMask.createMask(formMasks.rate).resolve("" + saturdayMaxRate)
              : null,
          },
          mask: formMasks.rate,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "saturdayRateRange",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        weekendSundayRate: {
          value: {
            sundayMinRate: sundayMinRate
              ? IMask.createMask(formMasks.rate).resolve("" + sundayMinRate)
              : null,
            sundayMaxRate: sundayMaxRate
              ? IMask.createMask(formMasks.rate).resolve("" + sundayMaxRate)
              : null,
          },
          mask: formMasks.rate,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "sundayRateRange",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
      },
    });
    const goBack = (formName) => {
      // let data = getFormValues(formName)
      $store.dispatch("setJobCreatePageData", getFormValues(formName));
      $router.push({
        name: "job_create_schedule",
      });
    };
    const goNext = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          $store.dispatch("setJobCreatePageData", getFormValues(formName));
          $router.push({
            name: "additional_information",
          });
        } else {
          setFormValidation(formName, false, false);
          console.log("error submit!!");
          return false;
        }
      });
    };

    watch(samePayRate, (value) => {
      
      if (value) {
        const ratesFields = ['weekendSaturdayRate', 'weekendSundayRate'];
        ratesFields.forEach((field) => {
            delete formsDataArray.dateForm[field].validators;
            if(field =='weekendSaturdayRate'){
                formsDataArray.dateForm[field].value = {
                saturdayMinRate: null,
                saturdayMaxRate: null,
              };
            }else{
              formsDataArray.dateForm[field].value = {
                sundayMinRate: null,
                sundayMaxRate: null,
              };
            }
            
        });
        // delete formsDataArray.dateForm.weekendSaturdayRate.validators;
        // formsDataArray.dateForm.weekendSaturdayRate.value.saturdayMinRate = null;
        // formsDataArray.dateForm.weekendSaturdayRate.value.saturdayMaxRate = null;
        // delete formsDataArray.dateForm.weekendSundayRate.validators;
        // formsDataArray.dateForm.weekendSundayRate.value.sundayMinRate = null;
        // formsDataArray.dateForm.weekendSundayRate.value.sundayMaxRate = null;
        formsDataArray.dateForm.weekendRate.validators =[
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "weekendRateRange",
                  callback,
                  setFormValidation
                );
              },
            },
          ];
        // checkFormValidation("dateForm", true);
      } else {
        delete formsDataArray.dateForm.weekendRate.validators;
         formsDataArray.dateForm.weekendRate.value.weekendMinRate = null;
        formsDataArray.dateForm.weekendRate.value.weekendMaxRate = null;
        if(!onlyCommonDays){
          delete formsDataArray.dateForm.rate.validators;
        }

        if(checkWeekend('saturday') && checkWeekend('sunday')){
          formsDataArray.dateForm.weekendSaturdayRate.validators = [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "saturdayRateRange",
                  callback,
                  setFormValidation
                );
              },
            },
          ];
        formsDataArray.dateForm.weekendSundayRate.validators = [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "sundayRateRange",
                  callback,
                  setFormValidation
                );
              },
            },
          ];
          checkFormValidation("dateForm", false,"weekendSundayRate");
          checkFormValidation("dateForm", false,"weekendSaturdayRate");
        }else if (checkWeekend('saturday') && !checkWeekend('sunday')){
          formsDataArray.dateForm.weekendSaturdayRate.validators = [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "saturdayRateRange",
                  callback,
                  setFormValidation
                );
              },
            },
          ];
        }else if(checkWeekend('sunday') && !checkWeekend('saturday')){
          formsDataArray.dateForm.weekendSundayRate.validators = [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "sundayRateRange",
                  callback,
                  setFormValidation
                );
              },
            },
          ];
        }
    
          // checkFormValidation("dateForm", false);
      }
      formHooks(formsDataArray);
    });

    const calculatePerHrRateSuper = (rateValue) => {
     
      // const minRate = formsData.dateForm.rate.value.minRate ? formsData.dateForm.rate.value.minRate :0;
      const result = ((rateValue * globalSuperCharge)-rateValue);
      const totalResult = result.toFixed(2);
      const parsedResult = parseFloat(totalResult);
      // return parsedResult;
      return Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(parsedResult);
    };

    const calculateTotalRate = (rateValue) => {
      // const minRate = formsData.dateForm.rate.value.minRate ? formsData.dateForm.rate.value.minRate : 0;
      const result =  ((rateValue * globalSuperCharge)-rateValue);
      const totalResult = result.toFixed(2);
      const totalInitilize = parseFloat(rateValue) + parseFloat(totalResult);
      // return totalInitilize;
      return Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(totalInitilize);

    };

    const {
      onFormMaskAccept,
      checkFormValidation,
      setFormValidation,
      getFormValues,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    // const checkWeekEnd = () => {
    //   for (const item in shedule) {
    //     const day = moment(shedule[item].date, "DD/MM/YYYY").format("dddd");
    //     if (day === "Saturday" || day == "Sunday") {
    //       return true;
    //     } else {
    //       formsData.dateForm.weekendRate.valid = true;
    //       formsData.dateForm.weekendSaturdayRate.valid = true;
    //       formsData.dateForm.weekendSundayRate.valid = true;
    //     }
    //   }
    // };

    const checkWeekend = (weekendOption) => {

      for (const item in shedule) {
        const day = moment(shedule[item].date, "DD/MM/YYYY").format("dddd");

        if (weekendOption === "all") {
          if (day === "Saturday" || day === "Sunday") {
            return true;
           
          }
        } else if (weekendOption === "saturday" && day === "Saturday") {
          return true;
        } else if (weekendOption === "sunday" && day === "Sunday") {
          return true;
        }else{
          formsData.dateForm.weekendRate.valid = true;
          formsData.dateForm.weekendSaturdayRate.valid = true;
          formsData.dateForm.weekendSundayRate.valid = true;

        }
      }


    };

    // const weekend = checkWeekEnd();

    const checkOnlyCommonDays = () => {
      for (const item in shedule) {
        const day = moment(shedule[item].date, "DD/MM/YYYY").format("dddd");
        if (
          day === "Monday" ||
          day === "Tuesday" ||
          day === "Wednesday" ||
          day === "Thursday" ||
          day === "Friday"
        ) {
          return true;
        } else {
          console.log("iam not weekdays");
          formsData.dateForm.rate.valid = true;
        }
      }
    };

    const onlyCommonDays = checkOnlyCommonDays();

    onMounted(() => {
      setPageClassGlobal("global_job_create_page");
      setFormRefs();

      const payload = {};
      if (!onlyCommonDays) {
        formsDataArray.dateForm.rate.value.minRate = null;
        formsDataArray.dateForm.rate.value.maxRate = null;
        payload.rate = { minRate: null, maxRate: null };
      }
      if (!checkWeekend("all")) {
        formsDataArray.dateForm.weekendRate.value.weekendMinRate = null;
        formsDataArray.dateForm.weekendRate.value.weekendMaxRate = null;
        payload.weekendRate = { weekendMinRate: null, weekendMaxRate: null };
      }
      if (!checkWeekend("saturday")) {
        formsDataArray.dateForm.weekendSaturdayRate.value.saturdayMinRate = null;
        formsDataArray.dateForm.weekendSaturdayRate.value.saturdayMaxRate = null;
        payload.weekendSaturdayRate = {
          saturdayMinRate: null,
          saturdayMaxRate: null,
        };
      }
      if (!checkWeekend("sunday")) {
        formsDataArray.dateForm.weekendSundayRate.value.sundayMinRate = null;
        formsDataArray.dateForm.weekendSundayRate.value.sundayMaxRate = null;
        payload.weekendSundayRate = {
          sundayMinRate: null,
          sundayMaxRate: null,
        };
      }
      if (Object.keys(payload).length) {
        $store.dispatch("setJobCreatePageData", payload);
      }

      formsRefs.dateForm.value.$el[0].focus();
      checkFormValidation("dateForm", false);
      if (checkWeekend("saturday") && checkWeekend("sunday")) {
        samePayRate.value = true;
      } else {
        samePayRate.value = false;
      }
      if (!onlyCommonDays) {
        delete formsDataArray.dateForm.rate.validators;
      }
    });

    return {
      formsData,
      onFormMaskAccept,
      checkFormValidation,
      goBack,
      goNext,
      // weekend,
      onlyCommonDays,
      samePayRate,
      checkWeekend,
      calculatePerHrRateSuper,
      globalSuperCharge,
      calculateTotalRate,
      isAustralia
    };
  },
};
</script>